export default {
    // 通用数据
    generalData: {
        date: "日期",
        searchTips: "请输入搜索关键词",
        modifyTime: "修改时间",
        name: "名称",
        submitTime: "提交时间",
        startTime: "开始时间",
        endTime: "结束时间",
        selectDate: "选择日期",
        startDate: '开始日期',
        endDate: '结束日期',
        submitter: "提交者",
        status: "状态",
        type: "类型",
        operation: "操作",
        none: "无",
        total: "总计",
        lastWeek: "最近一周",
        lastMonth: "最近一个月",
        theLastThreeMonths: "最近三个月",
        prompt: "提示",
        time: "时间",
        rateOfChange: "变化率",
        other: "其他",
        aTotalOf: "共",
        records: "条记录",
        image: "图片",
        video: "视频",
        text: "文案",
        script: "脚本",
        rate: "率",
        open: '开启',
        noOpen: '不启用',
        close: '关闭',
        high: "高",
        low: "低",
        determine: "确定",
        custom: '自定义',
        unlimited: '不限',
        set: '设置',
        sets: '套',
        detail: '详情',
        percentage: '占比',
        item: '条',
        yuan: '元',
        second: '秒',
        instance: '示例模板',
        quantity: '数量',
        import: '导入',
        enter: '请输入',
        required: '必填',
        optional: '选填',
        export: '导出',
        textCount: '字数',
        folder: '文件夹',
        target: '目标',
        currentDir: '当前目录',
        rootDir: '根目录',
        warning: {
            saveError: "保存失败，请重试",
            loadFail: "加载失败,请重试",
            synchronizeFail: "同步失败，请重试",
            operationFail: "操作失败，请重试",
            notSupport: '查看暂未支持',
            editFail: '编辑失败',
            tryAgain: '失败了,请重试',
            pushing: '推送中，请刷新列表查询结果',
            pushFail: '推送失败',
        },
        success: {
            saveSuccess: "保存成功！",
            submitSuccess: "提交成功！",
            synchronizeSuccess: "同步完成！",
            removeSuccess: "删除成功!",
            setSuccess: '设置成功',
            createSuccess: '创建成功',
            editSuccess: '编辑成功',
            freezeSuccess: '冻结成功',
            unfreezeSuccess: '解冻成功',
            enableSuccess: '启用成功',
            disableSuccess: '停用成功',
            pushSuccess: '推送成功',
        },
        placeholder: {
            pleaseChoose: "请选择",
            pleaseEnter: "请输入内容",
            pleaseSearch: "可输入进行搜索",
            all: "全部",
            enter: '请输入内容',
            userName: '请输入用户名',
            customer: '请输入客户名称',
        },
        select: {
            optional: "可选项",
            selectAll: "全选",
            selected: "已选",
            empty: "清空",
            isSelected: "已选中",
            chosen: '已选择'
        },
        range: {
            greater: "大于",
            smaller: "小于",
            between: "区间",
            eq: '等于',
            lt: '小于',
            gt: '大于',
        },
        confirm: {
            delete: "是否删除所选数据?",
            tag: "是否删除该标签？",
            enable: '确定启用',
            disable: '确定停用'
        }
    },

    //状态
    mkpStatus: {
        waitingForEdit: '待编辑',
        editing: '编辑中',
        waitingForConfig: '待配置',
        submitting: '提交中',
        success: '提交成功',
        fail: '提交失败',
        waitingUpdate: '待更新'
    },
    //按钮
    btns: {
        confirm: '确 定',
        cancel: '取 消',
        delete: "删除",
        add: "新 增",
        upload: "上传",
        edit: "修改",
        download: "下载",
        history: "历史",
        send: "发送",
        synchronizing: "同步中",
        synchronize: "同 步",
        select: "选择",
        application: "应用",
        search: "搜索",
        clearAll: "清空全部",
        submit: '提 交',
        clear: '清空',
        new: "新建",
        back: '返回',
        addTo: "添加",

        replace: "更换",
        edit2: "编辑",
        addEnter: '添加(回车键)',
        save: "保 存",
        filter: "筛选",
        reset: "重置",

        detail: '详情',
        view: '查看',
        share: '分享',
        assign: '分配',

        reservation:"预约",
        freeze: '冻结',
        copy: '复制',
        unfreeze: '解冻',
        play: "播放",
        preview: "预览",
        close: '关闭',
        jump: "跳转",
        push: '推送',
        enable: '启用',
        disable: '停用',
        pushLog: '记录',
        bind: '绑定',
        save: '保存'
    },
    // 图形呈现格式
    chartType: {
        showType: "呈现格式",
        table: "表格",
        histogram: "柱状图",
        barGraph: "条形图",
        lineVhart: "折线图",
        pieVhart: "饼状图",
        compound: "复合型",
    },
    //侧边栏
    sideBar: {
        creative: {
            creative: '推广',
            campaign: '广告组',
            campaignNew: '广告组创建',
            materialManager: '素材',
            historicalMaterial: '历史素材',
            setLabel: '编辑标签',
            creativeManager: '创意',
            creativeNew: '创建创意',
            creativeDetail: '创意详情',
            planList: '计划',
            planNew: '计划创建',
            planDeploy: '计划配置',
            planEdit: '编辑',
            planBulkEdit: '批量设置信息'
        },
        empower: {
            empower: '创意赋能',
            demand: '需求管理',
            material: {
                material: '素材库',
                picture: '图片',
                video: '视频',
                text: '文案',
                script: '脚本',
                webpage: '落地页',
                data: '客户文件',
                feedback: "反馈"
            },
            template: {
                template: '模板库',
                text: '文案',
                design: '设计',
                video: '视频',
            },
            materialData: '素材数据报表',
            mediaManage: '媒体管理',
            materialSet: '素材设置',
            actor: '演员库',
            resources: "资源库"
        },
        data: {
            data: '报表',
            advertiser: {
                advertiser: '广告报表',
                accountReport: '账户报表',
                campaignReport: '广告组报表',
                planReport: '广告计划报表',
                creativeReport: '广告创意报表',
                modelReport: '车型报表'
            },
            summary: {
                summary: '客户报表'
            },
            menu: {
                menu: '素材标签报表'
            },
						live: {
							live: '直播报表'
						},
            audience: {
                audience: '受众分析',
                advertiserAudience: '账户受众',
                campaignAudience: '广告组受众',
                planAudience: '广告计划受众',
                creativeAudience: '广告创意受众'
            },
            product: {
                product: '广告产品',
                creativeProductReport: '程序化创意',
                materialReport: '分素材统计',
                materialCount: '素材量统计',
                tagStat: '标签统计'
            }
        },
        secondWeb: {
            secondWeb: '二网素材',
            video: '视频库'
        },
        tiktok: {
            tiktok: 'TikTok',
            audience: {
                audience: '受众分析',
                campaign: '推广系列受众',
                adgroup: '广告组受众',
                ad: "广告受众"
            }
        },
        my: {
            my: "我的",
            myApplication: "我的申请",
            myApproval: "我的审批"
        },
        safety: {
            safety: '安全',
            permission: '用户授权',
            log: '操作日志',
            authorize: '二网授权',
        },
        set: {
            set: '设置',
            label: '标签管理',
            adr: '账户管理',
            media: '媒体管理',
            materialType: '素材类型',
            materialRule: '素材规则',
            mediaManage: '媒体管理',
            materialSet: '素材设置',
            carModel: '车型管理',
            scoreSet: '评分设置',
            copywriting: '文案句式管理',
            templateIcon: '模板库标签',
        },
        index: '首页',
        mediaScore: '媒体打分',
        mediaWeightedScore: '媒体排名',
        materialLibrary: '素材库',
        manageBoard: '管理看板',
        personalBoard: '个人看板',
        personalBoardNew: '新个人看板',
        automaticReport: '自动化报表',
        transform: {
            transform: '线索转发',
            nissan: '日产',
            vw: '大众',
            cadillac: '凯迪拉克',
            buick: '别克',
            chevrolet: '雪佛兰',
            svw: '大众二手车',
            consumer: '通用-获客中心',
            transformHistory: '转发历史'
        }
    },
    //登录页
    login: {
        username: '请输入用户名',
        password: '请输入密码',
        signin: '登 录',
        remember: '记住用户名与密码',
        wechat: "微信扫码登录",
        loading: "二维码加载中。。。"
    },
    //创意中心
    creative: {
        //素材管理
        material: {
            title: "推荐封面",
            
            label: {
                brandTag:"品牌标签",
                carBrand: '车型品牌',
                carModelTags: "品牌名称",
                brandTags: "品牌类标签",
                policyTags: "政策类标签",
                contentTags: "内容标签",
                customizeTags: "自定义标签",
                changeTime: "修改时间",
                materialType: "素材类型",
                SpecificationType: "效果通素材类型",
                name: "名称",
                tags: "标签",
                comments: "备注",
                material: "素材",
                image: "图片",
                video: "视频",
                text: "文案",
                brand: "品牌",
                myMaterial: "我的素材",
                localUpload: "本地上传",
                group: '分组',
                member: '成员',
                editGroup: "编辑分组",
                groupDetail: "分组详情", 
                account: "账户" 
            },
            message: {
                error: "有标签暂未填写完成！",
                success: "修改成功",
                validatePolicyAndBrand: "请设置品牌类标签或政策类标签",
                validatePolicyOrBrand: "品牌标签和政策标签只能二选一",
                imageError: "请选择图片",
                tagAPi: "标签设置成功！",
                addMaterial: "创建成功",
                handleUploadError: "失败了,请重试",
                editSuccess: "编辑成功",
                editFail: "编辑失败",
                fileLimit: "文件大小不能超过10MB",

                uploadImgSize: "建议最佳：宽高比9:16，720*1280≤尺寸≤1440*2560，支持JPG、PNG等图片格式",
                imgLength: "图片大小与视频大小不匹配",
                imgFormat: '请上传JPG、PNG等图片',
                imgCover: "请选择或者上传封面图",
                updateSuccess: "更新成功",
                noData: "暂无数据",
                fileMsg: "只能上传excel文件，且不超过10MB", 
            },
            radioLabelList: {
                image1: "画面元素",
                image2: "车身颜色",
                video1: "视频类型",
                video2: "视频风格",
                text1: "动态词包",
                text2: "字段篇幅",
            },
            // tmp:{
            //     text1:"动态词包",
            //     text2:"字段篇幅",
            //     video1:"视频类型",
            //     video2:"视频风格",
            //     image1:"画面元素",
            //     image2:"车身颜色",
            // },
            btns: {
                setLabel: "设置标签",
                exportTemplate: "导出模板",
                downLabelTpl: "模板下载",
                importMaterial: "导入素材",
                importTags:"批量导入标签",
                editTags: "编辑标签",
                editMaterial: "编辑素材",
                upload: "本地上传",
                finish: "完成",
                batch: "批量上传",
            },
            placeholder: {
                carModelTags: "请选择品牌名称",
                brandTagIds: "请选择品牌类标签",
                policyTagIds: "请选择政策类标签",
                all: "全部",
                carModel: "请选择车型",
                brand: "请选择品牌",
                customizeTag: "请选择自定义标签",
            },
            dynamicColum: {
                image: {
                    id: "图片ID",
                    name: "图片名称",
                    url: "图片",
                    type: "素材类型",
                    toutiaoType: "效果通素材类型",
                    MRType: "MR素材类型",
                    demandName: "需求名称"
                },
                video: {
                    id: "视频ID",
                    name: "视频名称",
                    url: "视频",
                    coverUrl: "封面图",
                    type: "素材类型",
                    toutiaoType: "效果通素材类型",
                    MRType: "MR素材类型"
                },
                text: {
                    id: "文案ID",
                    name: "文案名称",
                    content: "文案内容",
                    text: "字数",
                },
            },
            downLabelTmpl: "标签模板",
            downTmpl: "文案素材模板",
            selectedPerson: "已选",
            deleteSeleted: "人"
        },
        //创意管理
        creative: {
            creativeList: {
                //表单
                queryCriteria: {
                    creativeMode: '创意方式',
                    statue: '创意状态',

                },
                placeholder: {
                    searchValue: '创意ID/创意名称/创意标题',
                },
                status: {
                    online: '已上线',
                    notOnline: '未上线'
                },
                mkpCreativeMode: {
                    programmaticCreativity: '程序化创意',
                    customCreative: '自定义创意'
                },
                button: {
                    createCreative: '创建创意',
                    exportCreative: '导出创意',
                    view: '查看素材'
                },
                //报表列
                column: {
                    id: '创意ID',
                    mkpCreativeName: '创意名称',
                    mkpCreativeContent: '创意内容',
                    mkpCreativeTitle: '创意标题',
                    mkpCreativeMode: '创意方式',
                    mkpCreativeNum: '创意数量',
                    status: '创意状态',
                    gmtModified: '修改时间',
                    operating: '操作'
                }
            },
            creativeDetail: {
                ruleForm: {
                    mkpCreativeId: '创意ID',
                    mkpCreativeName: '创意名称',
                    article: '文案',
                    image: '图片',
                    video: '视频',
                    creativeTitle: '创意标题',
                    creativeContent: '创意内容'
                }
            },
            creativeNew: {
                label: {
                    creativeMode: '创意方式',
                    creativeNum: '创意个数',
                    creative: '创意',
                    materialType: '素材类型',
                    creativeContent: '创意内容',
                    creativeTitle: '创意标题',
                    creative_text: '选择文案',
                    creative_pic: '选择图片',
                    creative_video: '选择视频',
                    creativeName: '创意名称',
                    picNumber: '图片创意个数',
                    videoNumber: '视频创意个数',
                    textNumber: '文案个数',
                    least_text_pic_video: '请至少选择一个文案,并至少选择一个图片或视频',
                    fill_information: '自定义创意请填写完整信息',
                    generate: '将生成',
                    creatives: '条创意',
                    selectOne: '请选择一个创意',
                },
                placeholder: {
                    enter: '请输入图片ID/名称/标签/备注',
                },
                btns: {
                    addCreative: '添加创意'
                },
                error: {
                    mast: '自定义创意最多添加10个',
                },
                column: {
                    imageId: '图片ID',
                    imageName: '图片名称',
                    imageUrl: '图片',
                    materialType: '素材类型',
                    modelLabel: '品牌名称',
                    brandLabel: '品牌类标签',
                    policyLabel: '政策类标签',
                    contentLabel: '内容标签',
                    remarks: '备注',

                    videoId: '视频ID',
                    videoName: '视频名称',
                    videoUrl: '视频',
                    coverUrl: '封面图',

                    text: '文案',
                    textId: '文案ID',
                    textTitle: '文案标题',
                    textContent: '文案内容',
                }
            }
        },
        //计划管理
        plan: {
            planList: {
                exportForm: "计划列表",
                // 信息
                message: {
                    noError: "暂无错误信息",
                    planError: "请选择一个计划",
                    msgError: "请勾选待配置、提交成功、提交失败、待更新状态的计划进行配置"
                },
                //表单
                queryCriteria: {
                    mkpStatus: '状态'
                },
                placeholder: {
                    keyword: '计划ID/广告计划名称/客户名称/品牌'
                },
                button: {
                    createPlan: '创建计划',
                    exportPlan: '导出计划',
                    importPlan: '导入计划',
                    setPlan: '设置计划',
                    setCreative: '设置创意',
                    setPrice: '设置出价',
                    batchSetting: '批量设置',
                    view: '查看创意',
                    edit: '编辑',
                    setting: '配置',
                    retry: '重试',
                },
                //报表列
                column: {
                    ac: "网络",
                    id: '计划ID',
                    name: '计划名称',
                    status: '状态',
                    mkpCreativeMode: '创意方式',
                    adNum: '创意数量',
                    inventoryType: '广告位置',
                    materialAddWay: '素材添加方式',
                    source: '来源',
                    advancedCreativeType: '附加创意类型',
                    buttonText: '行动号召',
                    creativeDisplayMode: '任意素材转为视频',
                    generateDerivedAd: '最优创意衍生计划',
                    isCommentDisable: '广告评论',
                    creativeDisplayMode: '创意展现',
                    thirdIndustryName: '创意分类',
                    adKeywords: '创意标签',
                    trackUrl: '展示监测',
                    actionTrackUrl: '点击监测',
                    videoPlayTrackUrl: '视频播放监测',
                    videoPlayDoneTrackUrl: '视频播放完监测',
                    videoPlayEffectiveTrackUrl: '视频有效播放监测',
                    deliveryRange: '投放范围',
                    deliveryTargetStr: '投放目标',
                    deliveryContent: '投放内容',
                    externalUrl: '落地页链接',
                    convertTargetStr: '转化目标',
                    openUrl: '直达链接',
                    city: '地域',
                    genderStr: '性别',
                    ageStr: '年龄',
                    mkpCustomeTags: '自定义人群',
                    interestActionMode: '行为兴趣',
                    mkpAweme: '抖音达人',
                    superiorPopularityType: '精选流量包',
                    platform: '平台',
                    autoExtendEnabled: '智能放量',
                    articleCategory: '文章分类',
                    carrier: '运营商',
                    activateTypeStr: '新用户',
                    deviceBrand: '手机品牌',
                    launchPrice: '手机价格',
                    smartBidTypeStr: '出价方式',
                    flowControlModeStr: '投放方式',
                    budget: '预算',
                    scheduleTypeStr: '投放时间',
                    deliveryPeriod: '投放时段',
                    pricingStr: '付费方式',
                    cpaBid: '目标转化出价',
                    hideIfConvertedStr: '过滤已转化用户',
                    gmtModified: '修改时间',
                    operating: '操作'
                }
            },
            planEdit: {
                tab: {
                    creative: '创意信息',
                    plan: '计划信息',
                    bid: '预算与出价'
                },
                placeholder: {
                    groupName: '请输入创意组名',
                    inventoryTypes: '请选择广告位置',
                    source: '请输入来源',
                    creativeDisplayMode: '请选择展现形式',
                    toutiaoThirdIndustryId: '请选择创意分类',
                    adKeywords: '请创建创意标签',
                    trackUrl: '请输入展示监测',
                    actionTrackUrl: '请输入点击监测',
                    videoPlayTrackUrl: '请输入视频播放监测',
                    videoPlayDoneTrackUrl: '请输入视频播完监测',
                    videoPlayEffectiveTrackUrl: '请输入视频有效播放监测',

                    deliveryTarget: '请选择投放目标',
                    convertTarget: '请选择转化目标',
                    gender: '请选择性别',
                    age: '请选择年龄',
                    customCrowdType: '请选择自定义人群',
                    retargetingTagsInclude: '输入人群包ID，多个ID空格隔开，最多不超过10个',
                    actionScene: '所有行为场景',
                    interestActionMode: '请选择行为兴趣',
                    behaviorCategoryWords: '请输入行为类目词',
                    awemeMode: '请选择抖音达人',
                    awemeRemoteMethod: '支持搜索抖音达人、抖音昵称或抖音达人所在分类',
                    tiktokAuthors: '相关抖音达人',
                    tiktokCategories: '相关达人分类',
                    addAuthorCategories: '添加达人分类',
                    addTiktokAuthor: '添加抖音达人',
                    authorCategories: '达人分类',
                    awemeFanBehaviors: '请选择抖音达人行为',
                    superiorPopularityType: '请选择精选流量包',
                    province: '省份',
                    city: '城市',
                    in: '在',
                    select: '中，选择用户',
                    happen: '天内发生的行为',
                    unlimited: '不限',
                    choosePlatform: '请选择平台',

                    smartBidType: '请选择出价方式',
                    flowControlMode: '请选择投放方式',
                    budget: '请输入预算',
                    pricing: '请选择付费方式',
                    cpaBid: '请输入目标转化出价',
                    hideIfConverted: '请选择过滤已转化用户',

                    creativeGroup: '请选择创意信息组',
                    addCreativeGroup: '新增创意信息组',

                    creativeGroupName: '请选择创意组名'
                },
                ruleForm: {
                    adKeywords: '最多20个标签，每个不超过10个字，可空格分割',
                    customCrowdType: '请选择自定义人群',
                    interestActionMode: '请选择行为兴趣',
                },
                error: {
                    packages: '人群包有重叠',
                    authors: '抖音达人不能超过30个',
                    interest: '兴趣不能超过350个',
                    action: '行为不能超过350个',
                    least: '至少选择一个抖音达人行为'
                },
                genderList: {
                    female: '女',
                    male: '男',
                    none: '不限'
                },
                convertTargetList: {
                    form: '表单提交',
                    customer: '有效获客'
                },
                deliveryTargetList: {
                    click: '点击量',
                    transform: '转化量',
                    exposure: '展示量'
                },
                customCrowdTypeList: {
                    none: '不限',
                    custom: '自定义人群'
                },
                interestActionModeList: {
                    none: '不限',
                    recommend: '系统推荐',
                    custom: '自定义'
                },
                superiorPopularityTypeList: {
                    none: '不限',
                    app: '应用软件精选',
                    game: '游戏精选'
                },
                actionSceneList: {
                    e_commerce: '电商行为场景',
                    news: '资讯行为场景',
                    app: 'App行为场景'
                },
                awemeModeList: {
                    none: '不限',
                    custom: '自定义'
                },
                awemeBehaviorsList: {
                    followed_user: '已关注用户',
                    commented_user: '15天内已评价用户',
                    liked_user: '15天内已点赞用户',
                    shared_user: '15天内已分享用户'
                },
                creativeDisplayModeList: {
                    preferred_mode: '优选模式',
                    carousel_mode: '轮播模式'
                },
                inventoryTypesList: {
                    toupiao: '头条信息流',
                    xigua: '西瓜信息流',
                    hotsoon: '火山信息流',
                    tiktok: '抖音'
                },
                form: {
                    planId: '计划ID',
                    groupName: '创意组名',
                    inventoryTypes: '广告位置',
                    source: '来源',
                    creativeDisplayMode: '展现形式',
                    toutiaoThirdIndustryId: '创意分类',
                    adKeywords: '创意标签',
                    trackUrl: '展示监测',
                    actionTrackUrl: '点击监测',
                    videoPlayTrackUrl: '视频播放监测',
                    videoPlayDoneTrackUrl: '视频播完监测',
                    videoPlayEffectiveTrackUrl: '视频有效播放监测',

                    planGroupName: '计划组名',
                    deliveryTarget: '投放目标',
                    externalUrl: '落地页链接',
                    convertTarget: '转化目标',
                    regions: '地域',
                    gender: '性别',
                    age: '年龄',
                    customCrowdType: '自定义人群',
                    retargetingTagsInclude: '定向',
                    exclude: '排除',
                    interestActionMode: '行为兴趣',
                    action: '行为',
                    interest: '兴趣',
                    awemeMode: '抖音达人',
                    superiorPopularityType: '精选流量包',
                    platform: '平台',
                    behaviorCategory: '添加类目词',
                    behaviorCategoryWords: '添加关键词',
                    actionCategoriesNode: '类目词',
                    actionWords: '关键词',

                    smartBidType: '出价方式',
                    flowControlMode: '投放方式',
                    budget: '预算',
                    pricing: '付费方式',
                    cpaBid: '目标转化出价',
                    hideIfConverted: '过滤已转化用户',
                },
                budgetModeList: {
                    budgetModeDay: '日预算',
                    budgetModeTotal: '总预算'
                },
                flowControlModeList: {
                    flowControlModeFast: '优先跑量',
                    flowControlModeSmooth: '优先低成本',
                    flowControlModeBalance: '均衡投放'
                },
                smartBidTypeList: {
                    smartBidCustom: '手动',
                    smartBidConservative: '自动'
                },
                hideIfConvertedList: {
                    noExclude: '不过滤',
                    ad: '广告计划',
                    campaing: '广告组',
                    advertiser: '广告账户',
                    app: 'APP',
                    customer: '公司账户'
                }
            },
            planDeploy: {
                ruleForm: {
                    planGroup: '计划组',
                    planId: '计划ID',
                    planName: '计划名称',
                    adNum: '创意数量',
                    adGroup: '配置广告组',
                },
                column: {
                    advertiserName: '账号名称',
                    campaignName: '广告组',
                    adId: '计划ID',
                    touTiaoAdName: '计划名称'
                },
                placeholder: {
                    search: '搜索'
                },
                title: {
                    advertiser: '账号',
                    campaign: '广告组',
                    attention: '注意',
                    isUpdate: '以下计划处于投放中状态，是否确定更新'
                },
                message: {
                    campaign: '请选择广告组',
                    success: '配置成功'
                }
            },
            planNew: {
                ruleForm: {
                    adCreateType: '创建方式',
                    mkpCreativeMode: '创意方式',
                    adCreateType0: '批量创建计划',
                    adCreateType1: '创建单个计划',
                    mkpCreativeMode0: '自定义创意',
                    mkpCreativeMode1: '程序化创意',
                    chooseCreative: '选择创意'
                },
                rule: {
                    chooseOne: '请至少选择一个'
                },
                label: {
                    modelLabel: '品牌名称',
                    brandLabel: '品牌类标签',
                    policyLabel: '政策类标签',
                    contentLabel: '内容标签',
                    enterContent: '请输入创意ID/创意名称/标签',
                    chosen: '已选择'
                },
                column: {
                    id: '创意ID',
                    mkpCreativeName: '创意名称',
                    mkpCreativeContent: '创意内容',
                    mkpCreativeTitle: '创意标题',
                    carModelTags: '品牌名称',
                    brandTags: '品牌类标签',
                    policyTags: '政策类标签',
                    contentTag: '内容标签'
                }
            },
            setPlanForm: {
                planType: {
                    chooseGroup: '选择计划信息组',
                    addGroup: '新增计划信息组'
                },
                ruleForm: {
                    directional: '定向人群包',
                    exclude: '排除人群包',
                    headword: '类目词',
                    keyword: '关键词',
                    classify: '达人分类',
                    tiktok: '抖音达人'
                }
            }
        }
    },
     // 素材库
     materialLibrary: {
        label: {
            associatedGroup: '关联分组',
            uploadToutiao: '上传效果通',
            group: '用户分组',
            specificationType:'效果通类型'
        },
        message:{
            sendSuccess:'推送成功',
            relatedSuccess:'关联成功',
            uploading:'上传中...',
        }
    },
    // 线索转发
    transform:{
        label:{
            token:'token',
            project:'项目',
            secret: '密钥',  
            name: '名称',  
            client: '客户',  
            clueName: '项目名称',  
            clueType: '线索类型',  
            director: '负责人',  
            externalUrl: '落地页',  
            isSend: '是否下发',  
            source: '渠道来源',
            toutiaoSecret: '头条密钥',  
            toutiaoToken: '头条token', 
            dealer: '经销商名称',
            series: '车系名称',
            smartCode: 'smartCode',
            status: '状态',
            moduleId: '组件ID',
            mq: '媒体标识',
            mqType: '媒体标识类型',
            activity: '一级渠道',
            source: '二级渠道',
            bMediaId: '三级渠道',
            channelKeyId: '四级渠道',
            campaignCode: "活动代码",
            campaignName: "活动名称",
            mediaName: "媒体点位代码",
            sourceSub: "媒体名称",
            channelSource: '媒体说明',
            douyinId: '抖音ID',
            channelId: '渠道ID',
            channelSource1: 'channelsource',
            campaign: 'campaign',
            content: 'content',
            term: 'term',
            utmSource: 'utmSource',
            utmMedium: 'utmMedium',
            utmCampaign: 'utmCampaign',
            utmContent: 'utmContent',
            utmTerm: 'utmTerm',
            eventCode: 'eventCode',
            utmFilter: 'utmFilter'
        },
        placeholder: {
            token: '请输入token',
            name: '请输入名称',
            secret: '请输入密钥',
            client: '请输入客户',
            appId: '请输入appId',
            clueName: '请输入项目名称',
            appSecret: '请输入appSecret',
            clueType: '请选择线索类型',
            director: '请输入负责人',
            externalUrl: '请输入落地页',
            id: '请输入id',
            isSend: '请选择是否下发',
            pageId: '请输入pageId',
            smartCode: '请输入smartCode',
            source: "请输入渠道来源",
            accessSecretId: "请选择accessSecretId",
            dealer: '请输入经销商名称',
            series: '请输入车系名称',
            smartCode: '请输入smartCode',
            toutiaoSecret: '请输入头条密钥',
            toutiaoToken: '请输入头条token',
            startDate:'开始日期',
            endDate:'结束日期',
            moduleId: '请输入组件ID',
            mq: '请输入媒体标识',
            mqType: '请输入媒体标识类型',
            campaignCode: '请输入活动代码',
            campaignName: '请输入活动名称',
            mediaName: '请输入媒体点位代码',
            sourceSub: '请输入媒体名称',
            douyinId: '请输入抖音ID',
            channelId: '请输入渠道ID',
            channelSource: '请输入媒体说明',
            channelSource1: '请输入渠道来源',
            activity: "请输入一级渠道",
            vwSource: "请输入二级渠道",
            bMediaId: "请输入三级渠道",
            channelKeyId: "请输入四级渠道",
            utmSource: '请输入utmSource',
            utmMedium: '请输入utmMedium',
            utmCampaign: '请输入utmCampaign',
            utmContent: '请输入utmContent',
            utmTerm: '请输入utmTerm',
            eventCode: '请输入eventCode',
            utmFilter: '请输入utmFilter',
            source: '请输入五要素source',
            medium: '请输入五要素medium',
            campaign: '请输入五要素campaign',
            content: '请输入五要素content',
            term: '请输入五要素term',
            memo: '请输入备注'
        },
        button: {
            create: '新增',
            back: '返回',
            exportDealer: '导出经销商',
            exportModel: '导出车型',
            exportAllDealer: '导出全经销商'
        },
        title: {
            retry: '重试',
            detail: '详情',
        },
        historyLabel:{
            dealer: '经销商名称',
            series: '车系名称',
            gmtCreate: '记录同步时间',
            cluesId: '头条线索Id',
            clueIds: '车巴巴线索Id', 
            externalUrl: '落地页', 
            clueType: '线索类型', 
            isSend: '是否下发', 
            source: '渠道来源', 
            storeCodes: '店铺编码',
            name: '姓名', 
            telphone: '电话', 
            syncMsg: '转发状态', 
            msg: '错误信息', 
            otherInfo: '其他信息',
            moduleId: '组件ID',
            activity: '一级渠道',
            sourceVw: '二级渠道',
            bMediaId: '三级渠道',
            channelKeyId: '四级渠道',
            campaignCode: "活动代码",
            campaignName: "活动名称",
            mediaName: "媒体点位代码",
            sourceSub: "媒体名称",
            douyinid: 'douyinid',
            channelid: 'channelid',
            channelsource: 'channelsource',
            utmSource: 'utmSource',
            utmMedium: 'utmMedium',
            utmCampaign: 'utmCampaign',
            utmContent: 'utmContent',
            utmTerm: 'utmTerm',
            eventCode: 'eventCode',
            utmFilter: 'utmFilter',
            source: 'source',
            medium: 'medium',
            campaign: 'campaign',
            content: 'content',
            term: 'term',
            memo: '备注'
        },
        action:{
            edit: '编辑',
            delete: '删除',
            history: '转发历史',
            openUrl: '打开落地页',
            deactivate: '停用'
        },
        message: {
            createSucceed: '新建成功！',
            editSucceed: '编辑成功！',
            delete: '确认删除此记录？',
            export: '导出中...'
        },
    },
    // 报表汇总
    summary: {
        message: {
            confirm: '确认要删除该模板？',
            name: '请填写模板名称',
            edit: '已发送文件不支持修改',
            refresh: '请刷新重试',
            upload: '已发送文件不支持上传',
            uploadSize: '上传文件大小不能超过 500MB!',
            delete: '已发送文件不支持删除',
            file: '文件',
            uploadSuccess: '上传成功!',
            uploadFail: '上传失败! 请重试',
            selectOne: '表格，至少选择一项基础数据',
            selectTwo: '复合型图表，必须选择2项基础数据',
            pageErr: '页码必须大于1',
            pageRepeat: '页码不能重复',
            modelEmpty: '车型列表为空，请选择其他账号',
            formatError: '请上传excel文件',
            sizeError: '文件大小不能超过2M',
            complexErr: '复合型图表，必须选择2个基础数据',
        },
        form: {
            reportType: "报表类型",
            reportStatus: "报表状态",
            title: "输入模板名称",
            templateName: "模板名称",
            history: "历史",
            upload: "文件上传",
            dropFiles: "将文件拖到此处，或",
            clickToUpload: "点击上传",
            uploadWarning: "大小不超过500MB",
        },
        selectData: {
            daily: "日报",
            weekly: "周报",
            monthlyReport: "月报",
            summary: "总结",

            whole: "全部",
            generating: "生成中",
            buildFailed: "生成失败",
            generated: "已生成",
            downloaded: "已下载",
            adjusted: "已调整",
            hasBeenSent: "已发送",

            none: "无",
            total: "总计",
            audienceAnalysis: "受众分析",
            creativeAnalysis: "创意分析",
            platformComparison: "平台对比",
            materialStatistics: "素材量统计",
            landingPageAnalysis: "落地页分析",

            day: "分日",
            week: "分周",
            month: "分月",

            account: "账户",
            adGroup: "广告组",
            segmentationList: {
                INVENTORY: "投放位置",
                ADVERTISER_ID: "账号",
                PROVINCE_NAME: "省份",
                CITY_NAME: "城市",
                AGE: "年龄",
                GENDER: "性别",
                AD_TAG: "兴趣",
                INTEREST_TAG: "兴趣关键词",
                TOP5_CREATIVE: "TOP5消耗同时成本低的素材",
                CREATIVE_TAG: "创意标签占比",
                MATERIAL_INFO_PER: "素材类型消耗&留资成本对比",
                PLATFORM: "四大平台的消耗&留资成本对比",
                PROJECT_MATERIAL: "项目周期内累计投放素材统计",
                GOOD_CREATIVE: "优质创意统计",
                POOR_CREATIVE: "较差创意统计",
            }

        },
        model: {
            generateReports: "生成报表",
            editReport: "编辑报表",
            reportName: "报表名称",
            parameterTemplate: "参数模板",
            reportType: "报表类型",
            outputFormat: "输出格式",
            dataDimension: "数据维度",
            customerAccount: "客户账号",
            timeBreakdown: "时间细分",
            granularityBreakdown: "粒度细分",
            segmentData: "细分数据",
            basicData: "基础数据",
            selectAll: "全选",
            consumption: "消耗量",
            impressions: "展示数",
            traffic: "点击量",
            conversionVolume: "转化量",
            projectName: "项目名称",
            kpi: "KPI",
            pageNo: "页数",
            parameters: "参数",
            format: "格式",
            excelTemplate: '排序模板',
        },
        button: {
            saveAsTemplate: "存为模板",
            upLoadTemplate: '上传Excel排序模板'
        },
        placeholder: {
            reportType: "请选择报表类型",
            reportStatus: "请选择报表状态",
            templateInfo: "请选择参数模板",
            fileType: "请选择输出格式",
            idType: "请选择数据维度",
            segmentationType: "请选择粒度细分",
            segmentation: "请选择需要细分的数据",
            addReport: "请先新增报表",
            keyword: '请输入报表名称'
        },
        rules: {
            reportName: "请输入名称",
            reportNameLong: "长度在 1 到 50 个字符",
            advertiserIds: "请选择客户账号",
            campaignIds: "请选择广告组",
            dateRange: "请选择日期",
            projectName: "请输入项目名称",
            projectNameLong: "长度在 1 到 50 个字符",
            kpi: "请输入KPI",
            kpiNumber: "KPI必须是数字",
            carModelIds: '请选择车型',
            templateUid: '请上传excel模板',
        },
        delete: {
            title: "确认要删除该报表?"
        },
        hisColumn: {
            fileName: "名称",
            gmtCreate: "提交时间",
            creator: "提交者",
            fileType: "文件类型",
            download: "下载",
        }
    },
    //用户权限
    permission: {
        title: "修改权限",
        column: {
            username: "用户名",
            editPermissions: "编辑权限",
            bingSecondWeb: '关联二网用户',
            userList: "用户列表",
            roleList: "角色列表",
            group:"关联运营"
        }
    },
    // 操作日志
    log: {
        filterForm: {
            operatingRange: "操作范围",
            operationContent: "操作内容",
            unlimited: "不限"
        },
        placeholder: {
            range: "请选择操作范围",
            content: "请选择操作内容",

        },
        column: {
            module: "操作对象类型",
            name: "操作对象名称",
            description: "操作内容",
            userName: "操作人",
            gmtCreate: "操作时间",
        }
    },
    // 账户管理
    adr: {
        form: {
            name: "客户名称",
            advertiserIds: "下属账户",
        },
        removeClient: '确认要删除该客户?'
    },
    // 广告组选择组件
    adSelector: {
        title: "选择广告组",
        title2: "选择推广系列",
        selected: "已选",
        item: "项",
        chooseAccount: "请先选择账户",
        campaign: "推广系列",
        adGroup: "广告组",
        adPlan: "广告计划",
        adCreative: "广告创意",
    },
    // 数据中心
    dataCenter: {
        publicData: {
            account: "账户",
            hours: "分时",
            day: "分日",
            weeks: "分周",
            months: "分月",
            total: "合计",
            filter: "筛选",
            reset: "重置",
            collapse: "收起",
            unfold: "展开",
            downloadForm: "下载表格",
            compare: "对比"
        },
        // 广告报表
        report: {
            campaign: {
                landingTypeOptions: {
                    link: "销售线索收集",
                    app: "应用推广",
                    dpa: "产品目录推广",
                    goods: "商品推广（鲁班）",
                    store: "门店推广",
                    aweme: "抖音号推广",
                    shop: "电商店铺推广",
                }
            }
        },
        // 素材标签报表
        menu: {
            dialog: {
                dimension: "维度", 
                level: "层级",
                title: "图表" 
            },
            form: {
                customizeTag: "自定义标签",
                type: "类型" 
            },
            index: {
                tagName: "标签",
                cost: "消耗",
                show: "展示数",
                avgShowCost: "平均千次展示费用",
                click: "点击数",
                ctr: "点击率",
                avgClickCost: "平均点击单价",
                convert: "转化数",
                convertCost: "转化成本",
                convertRate: "转化率",
            },
            botton: {
                exportExcel: "导出Excel",
                viewChart: "查看图表",
            }
        },
        // 广告产品
        product: {
            // 程序化创意
            creative: {
                adCreative: "广告创意",
                creativeStyle: "创意样式",
                detailedData: "详细数据",
                subdivision: "细分",
                imageModeOptions: {
                    smallPicture: "小图",
                    bigPicture: "大图",
                    portrait: "大图竖图",
                    largePicture: "大图横图",
                    photos: "组图",
                    GIFImage: "GIF图",
                    horizontalVideo: "横版视频",
                    verticalVideo: "竖版视频",
                    searchBigPicture: "搜索大图",
                    searchThumbnail: "搜索小图",
                    pangolinOpenPicture: "穿山甲开屏图片",
                    pangolinOpenVideo: "穿山甲开屏视频",
                    title: "标题",
                },
                detailOptions: {
                    none: "无",
                    placement: "投放位置",
                    promotionPurpose: "推广目的",
                    billingMethod: "计费方式",
                    creativeStyle: "创意样式",
                    createCreativeStyles: "创意生成样式",
                    gender: "性别",
                    age: "年龄",
                    province: "省份",
                    cityTOP20: "城市TOP20",
                    interestClassification: "兴趣分类",
                    platform: "平台",
                    theInternet: "网络",
                    city: "城市"
                },
                requiredCols: {
                    time: "时间",
                    exploreStatus: "探索状态",
                    creativity: "创意",
                    account: "账户",
                    adGroup: "广告组",
                    adPlan: "广告计划",
                    status: "状态",
                    material: "素材",
                    model: '车型'
                },
                warning: {
                    date: "分时条件下日期范围不能大于7天！"
                }
            },
            // 分素材统计
            material: {
                label: {
                    adPlan: "广告计划",
                    search: "搜索",
                    materialType: "素材类型",
                    remarks: "备注",
                    modelLabel: "品牌名称",
                    brandLabel: "品牌标签",
                    policyLabel: "政策标签",
                    contentTag: "内容标签",
                    cost: "消耗",
                    transfer: "转化数",
                    transferCost: "转化成本",
                    show: "展示数",
                    material: "素材",
                    materialID: "素材ID",
                    accountID: "账户ID",
                    date: "时间",
                    createTime: "创建时间",
                    duration: "时长"
                },
                placeholder: {
                    materialName: "素材名称或ID",
                    remark: "搜索备注",
                },
                title: "详细数据",
                btns: {
                    downloadTable: "下载表格"
                }
            },
            // 标签统计
            label: {
                requiredCols: {
                    labelID: "标签ID",
                    labelName: "标签"
                }
            }
        },
        live: {
            column: {
                addFan: '新增粉丝',
                addFanRate: '转粉率',
                addGroup: '新加团人数',
                addGroupRate: '加团率',
                avgPeople: '平均在线人数',
                avgPeopleSee: '人均看播时长',
                dateStr: '时间',
                globalGmv: 'GMV',
                gmv: '投放转化GMV',
                goodsChick: '商品点击数',
                goodsChickRate: '商品点击率',
                liveCostRmb: '投放消耗',
                liveLike: '点赞数',
                maxPeople: '最高在线人数',
                orderNum: '成交单数',
                orderPeopleNum: '成交人数',
                orderRate: '成交转化率',
                reply: '评论数',
                saleGoods: '带货数量',
                salePrice: '客单价',
                saleTopFirst: '销量商品TOP1',
                saleTopSecond: '销量商品TOP2',
                saleTopThird: '销量商品TOP3',
                shareGoods: '商品曝光',
                timeStr: '时长',
                totalPeople: '总观看人数',
                account: '账号'
            }
        }
    },
    // advertiserSelector组件
    advertiserSelector: {
        placeholder: {
            account: "请选择账户",
            drag: "请拖拽素材到对应类型"
        },
        text: "暂无数据",
        loading: "加载中..."
    },
    // reportCharPanel组件
    reportCharPanel: {
        bar: {
            legendFilterOptions: {
                top5: "显示Top5",
                top: "显示Top10",
                sum: "显示汇总数据"
            }
        },
        index: {
            cost: "消耗",
            show: "展示数",
            avgShowCost: "平均千次展示费用",
            click: "点击数",
            ctr: "点击率",
            avgClickCost: "平均点击单价",
            convert: "转化数",
            convertCost: "转化成本",
            convertRate: "转化率",
            active: "激活数",
            register: "注册数",
            gameAddiction: "关键行为数",
            comment: "评论提交数",
            like: "点赞数",
            share: "分享数",
            follow: "新增关注数",
            homeVisited: "主页访问量",
            tabName: {
                trend: '时间趋势',
                proportion: '占比分析',
                compare: '累计对比'
            }
        }
    },
    // ColumnSelector组件
    columnSelector: {
        btns: {
            customColumn: "自定义列"
        },
        dialog: {
            columnName: "搜索列名称",
            addColumn: "可添加的列",
            selected: "已选择",
            column: "列"
        },
        activeParent: "设置数据"
    },
    // MaterialPiePanel组件
    materialPiePanel: {
        title: {
            top: "标签占比",
        },
        amountMaterial: "素材量"
    },
    //AudienceChartPanel组件
    audienceChartPanel: {
        area: {
            province: "省级分布",
            city: "地级市分布",
        },
        title: {
            chart: "受众图表",
            gender: "性别分布",
            age: "年龄分布",
            platform: "平台分布",
            tag: "兴趣分类分布",
            network: "网络分布"
        },
        label: "展示指标",
        indicatorFilterOptions: {
            cost: "消耗",
            show: "展示数",
            avgShowCost: "平均千次展示费用",
            click: "点击数",
            ctr: "点击率",
            avgClickCost: "平均点击单价",
            convert: "转化数",
            convertCost: "转化成本",
            convertRate: "转化率",
        }
    },
    //cascader组件
    cascader: {
        firstLabel: "一级标签",
        secondLabel: "二级标签",
        thirdLabel: "三级标签",
    },
    //user页面
    user: {
        label: {
            normal: "正常",
            frozen: "已冻结"
        },
        colunmn: {
            name: "用户昵称",
            time: "注册时间"
        },
        actions: {
            edit: "修改",
            freeze: "冻结账号",
            remove: "删除账号",
        }
    },
    //noPermission页面
    noPermission: {
        logOut: "回到登录界面",
        tips: "非常抱歉，您的账号未授权。请联系管理员解决。",
        message: {
            success: "退出登录成功",
            fail: "退出登录失败，请稍后重试",
            error: "没有可访问的页面路由"
        },
    },
    //noFound页面
    noFound: {
        message: "非常抱歉，没有找到该页面。",
        goBack: "回到主页",
        error: "没有找到页面"
    },
    //audience_cols.js
    audienceCols: {
        name: "效果指标",
        sub: {
            name: {
                presentationData: "展现数据",
                conversionData: "转化数据",
                videoData: "视频数据",
                interactiveData: "互动数据",
            },
            label: {
                // 展现数据
                cost: "消耗",
                show: "展示数",
                avgShowCost: "平均千次展现费用",
                click: "点击数",
                ctr: "点击率",
                avgClickCost: "平均点击单价",
                // 转化数据
                convert: "转化数",
                convertCost: "转化成本",
                convertRate: "转化率",
                deepConvert: "深度转化次数",
                deepConvertCost: "深度转化成本",
                deepConvertRate: "深度转化率",
                // 视频数据
                totalPlay: "播放数",
                validPlay: "有效播放数",
                validPlayRate: "有效播放率",
                validPlayCost: "有效播放成本",
                play25FeedBreak: "25%进度播放数",
                play50FeedBreak: "50%进度播放数",
                play75FeedBreak: "75%进度播放数",
                play100FeedBreak: "99%进度播放数",
                playOverRate: "播完率",
                averagePlayTimePerPlay: "平均单次播放时长",
                wifiPlayRate: "WiFi播放占比",
                // 互动数据
                follow: "新增关注数",
                like: "点赞数",
                comment: "评论数",
                share: "分享数",
                homeVisited: "推广页访问量",
                iesChallengeClick: "挑战赛查看数",
                iesMusicClick: "音乐查看数",
                locationClick: "POI点击数",
            }
        }
    },
    // report_cols.js
    reportCols: {
        name: {
            conversionData_time: "转化数据(计费时间)",
            appDownload: "应用下载广告数据",
            landingPage: "落地页及门店数据",
            additionalIdeas: "附加创意",
            performanceIndex: "效果指标",
            settingData: "设置数据",
            propertySetting: "属性设置",
        },
        label: {
            // 转化数据(计费时间)
            convert_time: "转化数(计费时间)",
            convertCost_time: "转化成本(计费时间)",
            deepConvert_time: "深度转化数(计费时间)",
            deepConvertCost_time: "深度转化成本(计费时间)",
            // 应用下载广告数据
            downloadStart: "安卓下载开始数",
            downloadStartCost: "安卓下载开始成本",
            downloadStartRate: "安卓下载开始率",
            downloadFinish: "安卓下载完成数",
            downloadFinishCost: "安卓下载完成成本",
            downloadFinishRate: "安卓下载完成率",
            installFinish: "安卓安装完成数",
            installFinishCost: "安卓安装完成成本",
            installFinishRate: "安卓安装完成率",
            active: "激活数",
            activeCost: "激活成本",
            activeRate: "激活率",
            register: "注册数",
            activeRegisterCost: "注册成本",
            activeRegisterRate: "注册率",
            gameAddiction: "关键行为数",
            gameAddictionCost: "关键行为成本",
            gameAddictionRate: "关键行为率",
            attributionNextDayOpenCnt: "次留数",
            attributionNextDayOpenCost: "次留成本",
            attributionNextDayOpenRate: "次留率",
            payCount: "付费数",
            activePayCost: "付费成本",
            activePayRate: "付费率",
            inAppUv: "APP内访问",
            inAppDetailUv: "APP内访问详情页",
            inAppCart: "APP内加入购物车",
            inAppOrder: "APP内下单",
            inAppPay: "APP内付费",
            loanCompletion: "完件数",
            loanCompletionCost: "完件成本",
            loanCompletionRate: "完件率",
            preLoanCredit: "预授信数",
            preLoanCreditCost: "预授信成本",
            loanCredit: "授信数",
            loanCreditCost: "授信成本",
            loanCreditRate: "授信率",
            // 落地页及门店数据
            phone: "点击电话按钮",
            form: "表单提交",
            mapSearch: "地图搜索",
            button: "按钮button",
            view: "关键页面浏览",
            download: "下载开始",
            qq: "QQ咨询",
            lottery: "抽奖",
            vote: "投票",
            message: "短信咨询",
            redirect: "页面跳转",
            shopping: "商品购买",
            consult: "在线咨询",
            wechat: "微信复制",
            phoneConfirm: "智能电话-确认拨打",
            phoneConnect: "智能电话-确认接通",
            consultEffective: "有效咨询",
            coupon: "建站卡券领取",
            couponSinglePage: "卡券页领取",
            // 附加创意
            advancedCreativePhoneClick: "附加创意电话按钮点击",
            advancedCreativeCounselClick: "附加创意在线咨询点击",
            advancedCreativeFormClick: "附加创意表单按钮点击",
            advancedCreativeCouponAddition: "附加创意卡券领取",
            // 设置数据
            toutiaoAdId: "广告计划ID",
            campaignName: "广告组",
            toutiaoCampaignId: "广告组ID",
        }
    },
    // navbar组件
    navbar: {
        name: "尊敬的用户",
        logOut: "退出登录"
    },
    // request.js文件
    request: {
        message: "您的登录已过期，可以取消继续留在该页面，或者重新登录",
        title: "确定登出",
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        error: "请求超时，请稍后重试"
    },
    // tableSelectMixin.js
    tableSelectMixin: {
        message: {
            materialChoose: "素材最多选择",
            piece: "个",
            customize: "自定义",
            programmatic: "程序化",
            creativityChoose: "创意最多选择",
        }
    },
    //TikTok
    tiktok: {
        // chartsRequest对象
        chartsRequest: {
            gender: '性别',
            age: '年龄',
            country: '国家',
            internet: '网络',
            language: '语言',
            system: '操作系统',
            interestOrientation: '兴趣定向',
            placement: '投放位置',
        },
        // audience_cols.js文件
        advertiserCols: {
            name: "广告受众",
            sub: {
                indexData: "指标数据",
                clickCnt: "点击数",
                conversionCost: "实时转化成本",
                conversionRate: "实时转化率",
                convertCnt: "实时转化数",
                ctr: "点击率",
                showCnt: "展示数",
                statCost: "消耗",
                timeAttrConvertCnt: "转化数",
            }
        },
        // 组件
        component: {
            area: {
                title: {
                    country: "国家分布",
                    audienceChart: "受众图表",
                    genderDistribution: "性别分布",
                    ageDistribution: "年龄分布",
                    platformDistribution: "平台分布",
                    interest: "兴趣分类分布",
                    internet: "网络分布",
                    language: "语言分布",
                    placement: "投放位置分布",
                    label: "标签占比",
                    modelLabel: "品牌名称",
                    brandLabel: "品牌标签",
                    policyLabel: "政策标签",
                    contentLabel: "内容标签",
                }
            },
            indicatorFilterOptions: {
                statCost: "消耗",
                showCnt: "展示数",
                clickCnt: "点击数",
                timeAttrConvertCnt: "转化数",
                ac: "网络",
                age: "年龄",
                conversionCost: "实时转化成本",
                conversionRate: "实时转化率",
                convertCnt: "实时转化数",
                country: "国家",
                ctr: "点击率",
                gender: "性别",
                interestCategory: "一级兴趣定向",
                language: "语言",
                placement: "版位",
                platform: "操作系统",
            }
        }
    },
    modifyPass: {
        name: "修改密码",
        form: {
            oldPass: "旧密码",
            newPass: "新密码",
            checkPass: "确认密码"
        },
        rules: {
            oldPass: "请输入旧密码",
            newPass: "请输入新密码",
            enterAgain: "请再次输入密码",
            inconformityPass: "两次输入密码不一致"
        },
        message: {
            success: "操作成功，请重新登录",
        }
    },
    empower: {
        demand: {
            createBtn: '新 建',
            model: {
                create: '新建',
                edit: '编辑',
                view: '查看',
                label: '标签',
                review: '审核',
                feedback: '反馈',
                close: '关闭订单',
            },
            statusList: {
                new: '新建',
                submitted: '已提交',
                complete: '完成',
                error: '有误',
                refuse: '拒绝',
                update: '更新'
            },
            typeList: {
                image: "图片",
                video: "视频",
                text: "文案",
                complex: '复合',
                script: '脚本',
                page: '落地页'
            },
            delete: '确认删除该记录？',
            share: '确定分享该素材？分享后，上次分享将失效。',
            searchTips: '请输入需求名称',
            placeholder: {
                modelLabel: "请选择品牌名称",
                brandLabel: "请选择品牌标签",
                policyLabel: "请选择政策标签",
                contentTag: "请选择内容标签",
            },
            form: {
                name: '需求名称',
                desc: '需求描述',
                case: '参考案例',
                reference: '客户资料',
                account: '账户',
                media: '媒体',
                demandList: '需求清单',
                actor: '演员',
                label: '全局标签',
                principal: '负责人',
                expectedTime: '期望完成时间',
                fileList: '文件列表',
                reason: '原因',
                lookRelated: '只看与我有关'
            },
            rules: {
                name: '请输入需求名称',
                desc: '请输入需求描述',
                case: '请选择参考案例',
                reference: '请选择参考资料',
                account: '请选择账户',
                media: '请选择媒体',
                demandList: '请选择需求清单',
                tag: '请选择4个全局标签',
                principal: '请选择负责人',
                expectedTime: '请选择期望完成时间',
            },
            column: {
                id: '需求号',
                name: '需求名称',
                expectedTime: '期待完成时间',
                gmtCreate: '提交时间',
                submiterName: '提交者',
                uploadTime: '上传时间',
                uploaderName: '上传者',
                type: '类型',
                statusDesc: '状态'
            },
            message: {
                leader: '请选择负责人',
                media: '请先选择媒体',
                tags: '请选择四种标签',
            },
            hisColumn: {
                demandName: '需求名称',
                tags: '全局标签',
                name: '文件名',
                content: '内容',
                style: '类型',
                size: '文件大小',
                status: '状态',
                media: '媒体',
                resource: '素材名称',
                number: '素材数量',
                leader: '素材负责人',
                rule: '素材规则'
            },
            prompt: {
                check: '审核',
                pass: '通过',
                noPass: '不通过',
                reason: '不通过，填写原因',
                warn: '请填写原因',
                submitText: '提交中...'
            },
            detailTitle: '需求详情',
            logColumn: {
                user: '操作员名称',
                content: '操作内容',
                time: '操作时间',
                type: '操作类型'
            },
            closeOptions: {
                test: '测试订单',
                cancel: '需求被取消',
                adjust: '调整',
                other: '其他'
            },
            logModalTitle: '取消订单记录',
            logData: {
                type: '取消订单类型',
                reason: '取消原因'
            }
        },
        material: {
            name: '素材管理',
            type: {
                image: "图片",
                video: "视频",
                text: "文案",
            },
            searchTips: {
                image: "请输入图片名称",
                video: "请输入视频名称",
                text: "请输入文案名称",
                data: '请输入文件名称',
            },
            name: '素材管理',
            label: {
                name: "名称",
                state: "状态",
                type: "类型",
                customer: "客户",
                keyword: "关键词",
                videoLink: "视频关联"
            },
            btns: {
                share: "分享",
                delete: "删除",
                upload: "上传",
                move: "移动",
                addFolder: '新建文件夹'
            },
            column: {
                // 图片
                picture: "图片/组图",
                pictureName: "名称",
                creationTime: "创建时间",
                updateTime: "更新时间",
                creator: "创建者",
                pictureType: "图片类型",
                size: "大小",
                demandNumber: "需求号",
                state: "状态",
                operation: "操作",
                // 视频
                video: "视频",
                videoType: "视频类型",
                videoName: "视频名称",
                cover: "封面",
                // 文案名
                copyName: "文案名",
                copyContent: "文案内容",
                // 脚本
                scriptName: "脚本名",
                scriptDescription: "描述",
                // 资料库
                fileName: "文件名",
                type: "类型",
                keyword: "关键字",
                model: "车型",
                customer: "客户",
                content: "内容",
                thumbnail: "缩略图",
                preview: "预览",
                // 脚本
                scriptName: "脚本名",
                type: "类型",
                //落地页
                screenshot: "落地页"
            },
            operation: {
                edit: "编辑",
                delete: "删除",
                share: "分享",
                feedback: "反馈",
                view: "预览",
                download: "下载",
                move: '移动'
            },
            ruler: {
                demandNumber: "未选择需求号",
                media: "未选择媒体",
                pictureType: "未选择图片类型",
                videoType: "未选择视频类型",
                textType: "未选择文案类型",
                cover: "未上传封面",
                keyword: "未输入关键字",
                name: "未输入名称",
                sName: "未输入脚本名",
                content: "未输入内容",
                model: "未选择车型",
                customer: "未选择客户",
                type: "未选择类型",
                gImg1: "请上传",
                gImg2: "张图片",
            },
            dialog: {
                demandNumber: "需求名称",
                media: "媒体",
                pictureType: "图片类型",
                videoType: "视频类型",
                textType: "文案类型",
                cover: "封面",
                type: "类型"
            },
            confirm: {
                IMAGE: "请先选择图片类型再上传！",
                VIDEO: "请先选择视频类型再上传！",
                TEXT: "请先选择文案类型再上传！",
                data: "请先选择资料类型再上传！",
                SCRIPT: "请先选择脚本类型再上传！",
                uploadSize: "上传文件大小不正确！",
                uploadFormat: "上传文件格式不正确！",
                file: "未上传文件！",
                selected: "未选中数据！",
                cover: "未上传封面！",
                excel: "选择Excel文件上传",
                excelError: "上传失败，请确认文件内容是否正确！",
                waitUpload: "请等待文件上传完成！",
                gImg: "请上传正确的图片数量！",
                waitUpload: "请等待文件上传完成！",
                uploading: "正在上传文件！",
            },
            status: {
                init: '初始化',
                complete: '完成',
                refuse: '拒绝',
                error: '有误'
            },
            message: {
                size: '落地页大小不能超过20M',
                requireUrl: '请输入落地页链接',
                errorUrl: '链接格式错误',
                tpltips: '点击下载上传模板',
            }
        },
        materialData: {
            label: {
                account: "账号",
                type: "类型",
                time: "时间",
                label: "标签",
                timeGranularity: "时间粒度"
            },
            column: {
                account: "账户",
                time: "时间",
                label: "标签",
                totalMaterials: "素材总数",
                totalNumberOfOnlineMaterials: "在线素材总数",
            }
        },
        mediaManage: {
            filterForm: {
                placeholder: '状态筛选',
                all: '全部'
            },
            status: '状态',
            mediaName: '媒体名称',
            description: '描述',
            unfreeze: '解冻',
            freezeConfirm: '确认要冻结该媒体？',
            unfreezeConfirm: '确认要解冻该媒体？',
            deleteConfirm: '确认要删除该媒体',
            rules: {
                mediaName: "请输入名称",
                mediaNameLength: "长度在 1 到 50 个字符",
            }
        },
        materialConfig: {
            formLabel: {
                media: '媒体',
                type: '类型',
                status: '状态',
                toutiao: '效果通类型',
            },
            placeholder: {
                media: '请选择媒体',
                type: '请选择类型',
                status: '请选择状态',
                len: '英文、数字、空格算半个字符',
                format: '请选择文件格式',
                keyword: '请输入素材名称'
            },
            column: {
                name: '名称',
                description: '描述',
                type: '类型',
                rules: '规则',
                media: '媒体',
                status: '状态',
                text: '文案句式',
            },
            form: {
                name: '素材名称',
                description: '描述',
                media: '所属媒体',
                type: '素材类型',
                format: '文件格式',
                videoRate: '视频码率',
                audioRate: '音频码率',
                duration: '时长',
                dim: '尺寸',
                resolution: '分辨率',
                width: '宽度',
                height: '高度',
                ratio: '宽高比',
                size: '文件大小',
                len: '字符长度',
                gImg: "是否组图",
                count: "组图数量"
            },
            rules: {
                name: "请输入名称",
                nameLength: "长度在 1 到 50 个字符",
                media: '请选择媒体',
                type: '请选择素材类型'
            }
        },
        actor: {
            deleteBtn: '删 除',
            form: {
                name: '姓名',
                gender: '性别',
                birth: '出生',
                height: '身高',
                weight: '体重',
                measurements: '三围',
                price: '报价区间',
                image: '形象',
                work: '作品',
                appearance: '外貌',
            },
			column: {
                name: '姓名',
                image: '形象',
                gender: '性别',
                birth: '出生',
                height: '身高',
                measurements: '三围',
                price: '报价区间',
                updateTime: '更新时间',
                updater: '更新人',
                status: '状态'
            },
            title: {
                info: '个人信息',
                work: 'Work',//作品
                effect: '作品投放效果',
            },
            detailColumn: {
                id: '素材ID',
                image: '素材缩略图',
                cons: '消耗',
                impressions: '展示数',
                hits: '点击数',
                clickRate: '点击率'
            },
            confirm: {
                freeze: '确定冻结该演员',
                unfreeze: '确定解冻该演员'
            },
            success: {
                freeze: '冻结成功',
                unfreeze: '解冻成功'
            },
            message: {
                noRecord: '请选择一条记录',
                name: '请输入姓名',
                gender: '请选择性别',
                tall: '请输入身高',
                tallError: '身高必须是正整数',
                weight: '请输入体重',
                weightError: '体重是正数，最多保留两位小数',
                measurements: '请输入三围',
                measurementsError: '三围格式必须是：90-80-70',
                price: '请输入价格',
                priceError: '价格是正数，最多保留两位小数',
                priceError2: '左侧价格不能高于右侧价格',
                cover: '请上传形象照',
                upload: '只能上传图片或视频文件',
                appearance: '请选择属性',
            },
            searchTips: {
                tall: '请输入身高',
                keyword: '请输入演员姓名'
            },
            appearance: {
                young: '年轻',
                mature: '偏成熟',
                middle: '中老年',
                child: '儿童',
            }
        },
        resources: {
            tab: {
                actor: "演员库",
                props: "道具库",
                scene: "场景库",
            },
            form: {
                name: '姓名',
                gender: '性别',
                age:"年龄",
                style:"风格",
                attribute:"属性",
                price: '报价区间',
                height: '身高',
                history:"合作历史",
            },
            btns:{
                apply:"外部演员申请",
                review:"申请审核",
                reservation:"预约"
            },
            column: {
                name: '姓名',
                image: '形象',
                gender: '性别',
                birth: '出生',
                age:"年龄",
                style:"风格",

                height: '身高',
                measurements: '三围',
                price: '报价区间',
                attribute:"属性",
                history:"合作历史",


                updateTime: '更新时间',
                updater: '更新人',
                status: '状态'
            },
            confirm: {
                freeze: '确定冻结该演员',
                unfreeze: '确定解冻该演员'
            },
            success: {
                freeze: '冻结成功',
                unfreeze: '解冻成功'
            },
            applyForm:{
                name:"项目名称",
                type:"演员类型",
                count:"拍摄视频条数",
                location:"拍摄地点",
                date:"拍摄时间",
                demand:"自带服装要求",
                remark:"备注",
            },
            review:{
                title:"申请列表",
                date:"申请提交时间",
                type:"申请类型",
                actor:"申请演员",
                name:"项目名称",
                person:"申请人",
                status:"状态",
                operating:"操作",
                review:"审核",
                view:"查看",
            },
            table:{
                date:"申请时间",
                person:"申请人",
                actor:"预约演员",
                refuse:"拒绝",
                pass:"通过",
                title1:"外部演员申请审核",
                title2:"预约演员申请审核",
            },
            reservation:{
                title:"预约申请",
                actor:"演员",
                date:"时间选择"
            },
        },
        template: {
            searchTips: {
                design: '请输入设计名称',
                video: "请输入视频名称"
            },
            label: {
                industry: "行业",
            },
            btns: {
                share: "分享",
                delete: "删除",
                upload: "上传",
                batchDelete: "批量删除",
                batchPass: "批量通过",
            },
            ruler: {
                type: "未选择类型",
                industry: "未选择行业",
                relatedResource: "未选择相关资源",
                typeOrIndustry: '类型和行业必须选一个',
            },
            dialog: {
                videoName: "视频名称",
                designName: "设计名称",
                downloadVideo: "下载视频",
                downloadProject: "下载工程视频",
                downloadPSD: "下载PSD",
                downloadPNG: "下载PNG",
                relatedDesign: "相关设计",
                relatedVideo: "相关视频",
                uploadVideo: "视频",
                uploadProject: "工程文件",
                materialID: "素材ID",
                recentlyEdited: "最近修改者",
                lastModifiedTime: "最近修改时间",
                size: "大小",
                tags: "标签",
                duration: "时长",
                pixel: "尺寸",
            },
            sort: {
                lastTime: "最近修改时间最近优先",
                download: "下载次数最多优先",
                mostResource: "关联资源数量最多优先",
            },
            message: {
                requireName: "请输入名称",
                requireType: "请选择类型",
                requireIndustry: "请选择行业",
                requireResource: "请选择关联资源",
                requireFile: "请上传文件",
                chooseTips: "未选中数据！",
                generateZero: "生成0条内容"
            }
        }
    },
    share: {
        title: '分享',
        copyImg: '鼠标右键点击二维码，选择复制二维码',
        copySuccess: '复制成功'
    },
    message: {
        msg: "消息",
        column: {
            title: '标题',
            status: '状态',
            time: '时间',
        },
        btns: {
            read: '已读',
            unread: '未读',
        },
        message: {
            read: '已标记为已读',
            delete: '确定删除该消息？',
            allRead: '确定将选中的消息标记为已读？',
            allDelete: '确定删除选中的消息？'
        }
    },
    secondWeb: {
        video: {
            column: {
                id: '记录ID',
                filename: '文件名',
                imageUrl: '封面',
                fileUrl: '视频',
                size: '大小',
                uploader: '上传者',
                gmtCreate: '上传时间'
            },
            form: {
                content: '水印内容',
                size: '字体大小',
                color: '文字颜色',
                position: '文字位置',
                time: '水印出现时间',
                bg: '背景颜色',
                opacity: '背景透明度',
                weight: '字体粗细',
                family: '字体'
            },
            message: {
                formatErr: '请上传正确的视频格式',
                sizeErr: '上传视频大小超过50MB',
                nameErr: '请输入正确的视频文件名',
                content: '请输入水印内容',
                color: '请选择文字颜色',
                uploadWarning: '只能上传视频文件，且不超过50M',
                showTime: '从第几秒开始显示',
                bg: '请选择背景颜色'
            },
            opacityList: {
                opaque: '不透明',
                transparent: '全透明',
            },
            fontFamilyList: {
                Yahei: '微软雅黑',
                SimSun: '宋体',
                SimHei: '黑体',
                JhengHei: '微软正黑体',
                KaiTi: '楷体',
                NSimSun: '新宋体',
                FangSong: '仿宋',
                PingFang: '苹方',
                STHeiti: '华文黑体',
                STKaiti: '华文楷体',
                STSong: '华文宋体',
                STFangsong: '华文仿宋',
                STZhongsong: '华文中宋 ',
                STHupo: '华文琥珀',
                STXinwei: '华文新魏',
                STLiti: '华文隶书',
                STXingkai: '华文行楷'
            },
            fontWeight: {
                normal: '正常',
                bold: '加粗'
            }
        }
    },
    wechat: {
        bind: "绑定微信",
        sacnCode: "扫码绑定微信",
        unbind: "解绑微信",
        message: "是否解除微信绑定？",
        unBindSuccess: "微信绑定已解除！",
        bindSuccess: "微信绑定成功！"
    },
    campaign: {
        label: {
            infinite: '不限',
            specify: '指定预算',
            total: '总预算',
            budget: '日预算',
            selectType: '请选择推广目的类型',
            name: '请输入广告组名称',
            campaignName: '广告组名称',
            campaignBudget: '广告组预算',
            deliveryRelatedNum: '广告组商品类型',
            NDPA: '非DPA',
            SDPA: 'SDPA 单商品推广',
            DPA: 'DPA 商品推广',
            carModel: '关联车型',
            advertiserName: '广告主名称',
        },
        message: {
            name: '广告组名称不能为空',
            budgetFormat: '预算最多支持两位小数',
            budgetLimit: '预算，不低于300.00元，不超过9,999,999.99元',
            budgetEmpty: '请输入广告组预算，不低于300.00元，不超过9,999,999.99元',
            carModel: '请选择关联车型',
        },
        landingType: {
            APP: {
                title: '应用推广',
                info: '提升应用的下载、安装、激活、付费'
            },
            LINK: {
                title: '销售线索收集',
                info: '提升销售线索的获取量'
            },
            AWEME: {
                title: '抖音号推广',
                info: '提升抖音号的粉丝量、互动量'
            },
            STORE: {
                title: '门店推广',
                info: '提升线下门店的到店效果'
            },
            SHOP: {
                title: '电商店铺推广',
                info: '提升电商店铺的产品销量'
            },
            DPA: {
                title: '产品目录推广',
                info: '提升产品目录的曝光与点击'
            },
            GOODS: {
                title: '商品推广',
                info: '提升商品的曝光与点击'
            },
        },
        column: {
            name: '广告组名称',
            target: '推广目的',
            type: '商品类型',
            budget: '预算',
            carModel: '关联车型',
            create: '创建时间',
            operation: '操作类型',
            batchNo: '推送批次',
            pushStatus: '推送状态'
        }
    },
    carModel: {
        column: {
            id: '车型ID',
            carModelName: '车型名称',
            advertiserGroupName: '客户名称',
            carModelCode: '车型代码',
            gmtCreate: '创建时间'
        },
        placeholder: {
            advertiserGroupIds: '请选择客户账号',
            carModelName: '请输入车型名称',
            carModelCode: '请输入车型代码',
            advertisers: '请选择广告主',
            campaign: '请选择广告组',
        },
        label: {
            advertisers: '广告主',
            toutiaoCampaignIds: '广告组',
            keyword: '关键字',
        },
        message: {
            warn: '至少选择一项'
        },
        title: '广告组绑定车型',
    },
    board: {
        today: '今日数据',
        timeStr: '更新时间',
        score: '个人评分',
        demandNum: '完成需求数',
        resourceNum: '完成素材数',
        demandNum2: '需求数',
        resourceNum2: '素材数',
        demandDoing: '进行中需求',
        resourceDoing: '进行中素材 ',
        avgDifficulty: '需求平均难度',
        avgCompletionTime: '平均素材完成天数',
        demandList: '需求列表',
        resourceList: '素材列表',
        completionTime: '完成时间分布',
        styleProportion: '素材类型占比',
        materialType: '素材类型',
        materialSubType: '素材子类型',
        demandAndChart: '个人进行中需求&素材数量趋势图',
        kpiList: '详细指标列表',
        statusOptions: {
            processing: '进行中',
            completed: '已完成'
        },
        dateOptions: {
            15: '近15天',
            30: '近30天',
            90: '近90天',
            180: '近180天',
            365: '近365天'
        },
        resourceTypeOptions: {
            image: '图片',
            video: '视频',
            text: '文案',
            script: '脚本',
            webpage: '落地页'
        },
        columns: {
            demandName: '需求名称',
            totalResourceCount: '需求素材数',
            personalResourceCount: '个人负责素材数',
            costProportion: '素材消耗占比',
            avgDifficulty: '平均难度',
            avgCompletionDays: '平均完成天数',
            demandStatus: '需求状态',
            materialCount: '需求总素材数',
            imageCount: '图片数量',
            videoCount: '视频数量',
            textCount: '文案数量',
            scriptCount: '脚本数量',
            locationCount: '落地页数量',
            completionDays: '完成天数',
            userName: '姓名',
            completionDemand: '完成需求',
            completionResource: '完成素材',
            resourceStyleName: '需求素材',
            resourceDifficulty: '素材难度',
            resourceStatus: '素材状态'
        },
        more: '以上',
        summary: '需求数据概况',
        demandSum: '需求总数',
        resourceSum: '完成素材总数',
        avgDifficultySum: '总平均难度',
        personalDetail: '人员详细数据',
        personalName: '请输入人员名称',
        export: '导出excel',
        finishType: '完成素材类型',
        finishSubType: '完成素材子类型',
        finishProportion: '完成素材类型占比'
    },
    templateIcon: {
        label: {
            libType: '所在库',
            tag: '标签',
            parent: '上一级',
            tagName: '标签名称',
        },
        searchText: '请输入标签名称',
        option: {
            industry: '行业',
            kind: '类型',
            text: '文案库',
            design: '设计库',
            video: '视频库'
        }
    },
    setCopyWriting: {
        btn: {
            createText: '新增句式',
            createType: '新增分类'
        },
        label: {
            type: '分类',
            pattern: '句式',
            part: '组成部分',
            name: '名称',
            model: '输入类型',
            label: '标签',
            typeName: '分类名称'
        },
        placeholder: {
            searchText: '请输入句式名称',
            industry: '请选择行业',
            type: '请选择分类',
            pattern: '请添加句式',
            labelName: '请选择标签',
            tagName: '请输入标签名称',
            libType: '请选择所在库'
        },
        option: {
            manual: '手动',
            manualAuto: '手动&自动'
        }
    },
    copywriting: {
        textLink: '在线生成文字链',
        label: {
            selectText: '句式选择',
            batchCreate: '批量生产',
            generateCon: '生成内容',
            autoGenerate: '自动生成',
            serial: '序号',
            textEdit: '文字链编辑',
            importText: '导入文案',
            fileWarn: '只能上传excel文件，且不超过10MB',
            editor: '编辑者',
            editTime: '编辑时间',
            enterCon: '填入内容',
            emptyWarn: '手动输入部分不能为空',
            selectTextWarn: '请先选择句式',
            textEmptyWarn: '请输入句式内容',
            wordRange: '字数范围',
            generateNum: '生成数量',
        },
        rules: {
            WordInteger: '字数范围必须是正整数',
            wordError: '字数范围开始值不能大于结束值',
            wordEmpty: '字数范围不能为空',
            countInteger: '生成数量必须是正整数',
            countEmpty: '生成数量不能为空'
        }
    },
    folder: {
        emptyErr: '目标文件夹不能为空'
    }
}
